import React from "react";
import {useTranslation} from "react-i18next";

const Login = () => {
    const {t} = useTranslation();

    return (
        <div className="container d-flex justify-content-center align-items-center py-5" data-aos="fade-up">
            <div className="col-md-6 col-lg-4">
                <div className="card shadow-lg">
                    <div className="card-body p-4">
                        <h3 className="text-center mb-4">{t("loginTitle")}</h3>
                        <form>
                            <div className="mb-3">
                                <label className="form-label">{t("email")}</label>
                                <input type="email" className="form-control" placeholder={t("email")}/>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">{t("password")}</label>
                                <input type="password" className="form-control" placeholder={t("password")}/>
                            </div>

                            <div className="mb-3 form-check">
                                <input type="checkbox" className="form-check-input" id="rememberCheck"/>
                                <label className="form-check-label" htmlFor="rememberCheck">{t("remember")}</label>
                            </div>

                            <button type="submit" className="btn btn-primary w-100">
                                {t("submit")}
                            </button>
                        </form>

                        <p className="text-center mt-3">
                            {t("noAccount")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;